<div>
    <div style="margin-left: 70%;  margin-bottom: 2%">
        <!-- <button class="btn btn-info" mat-raised-button (click)="assigndisrep()">
                Add Distribution Rep.
            </button> -->
        <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
            printSectionId="print-section" ngxPrint [useExistingCss]="true">
            print
        </button>
        <button mat-dialog-close onclick="closeexp()" class="btn noPrint">Close</button>
    </div>
    <div class="container" id="print-section">
        <div class="wrapper">
            <div class="row rowborder">
                <div class="common">
                    <span>दिनांक : </span>
                    <span>पृष्ठ क्र : 1</span>
                </div>
                <div class="common" style="margin-right: 20px;">
                    <span>हिंदुस्थान प्रकाशन संस्था</span>
                    <span>विवेक साप्ताहिक</span>
                    <span>खर्च खाते अनूपुस्तिका</span>
                </div>
            </div>
            <div class="row rowborder" style="gap: 0;">
                <div class="col-2 common">
                    <span>सांकेतांक</span>
                    <span>दिनांक</span>
                </div>
                <div class="col-4">
                    <span style="font-size: 14px;font-weight: bold">तपशील: {{expname}}</span>
                </div>
                <div class="col-2">
                    <span style="font-size: 14px;font-weight: bold">डेबिट</span>
                </div>
                <div class="col-2">
                    <span style="font-size: 14px;font-weight: bold">क्रेडिट</span>
                </div>
                <div class="col-2">
                    <span style="font-size: 14px;font-weight: bold">रक्कम</span>
                </div>
            </div>
            <div class="row rowborder">
                <div class="col-2">
                    <span>हिशेब खाते :</span>
                </div>
                <!-- <div class="col-1"></div> -->
                <div class="col-2">
                    <span>expense name</span>
                </div>
                <div class="col-2">
                    <span>मागील बाकी :</span>
                </div>
                <div class="col-2">
                    <!-- <span>{{ dr_opening_bal | number:'1.2-2' }}</span> -->

                </div>
                <div class="col-2">
                    <!-- <span>{{cr_opening_bal | number:'1.2-2'}}</span> -->
                </div>
            </div>
            <div class="row" *ngFor="let item of allvoucherdata">
                <ng-container *ngIf="item.voucher">
                    <div class="col-3 common">
                        <span>{{ item['voucher_no'] }}</span>
                        <span>{{ item['voucher_date']}}</span>
                        <span *ngIf="item.narration">narration: {{ item.narration }}</span>
                    </div>
                    <div class="col-3">
                        <span *ngIf="item['exp_detail']; else showExpName" style="font-weight: bold">
                            {{ item['exp_detail'] }}
                        </span>
                        <ng-template #showExpName>
                            <span *ngIf="item['exp_name']" style="font-weight: bold">
                                {{ item['exp_name'] }}
                            </span>
                        </ng-template>

                        <span *ngIf="item['rep_name']" style="font-size: 10px; margin-left: 2px;">
                            (rep_name: {{ item['rep_name'] }})
                        </span>

                        <span *ngIf="item['sub_type']" style="font-size: 10px; margin-left: 2px;">
                            (sub_type: {{ item['sub_type'] }})
                        </span>

                        <span *ngIf="item['advt_name']" style="font-size: 10px; margin-left: 2px;">
                            (advt_name: {{ item['advt_name'] }})
                        </span>

                        <span *ngIf="item['name']" style="font-size: 10px; margin-left: 2px;">
                            (book_seller: {{ item['name'] }})
                        </span>

                        <span *ngIf="item['narration']" style="font-size: 10px; margin-left: 2px;">
                            (narration: {{ item['narration'] }})
                        </span>

                        <span *ngIf="item['pan_card']" style="font-size: 10px; margin-left: 2px; color: gray;">
                            [PAN: {{ item['pan_card'] }}]
                        </span>
                    </div>
                    <div class="col-2">
                        <span *ngIf="item.voucher == 'dr'">
                            {{ item['exp_amt'] | number:'1.2-2' }}
                        </span>
                    </div>
                    <div class="col-2">
                        <span *ngIf="item.voucher == 'cr'">
                            {{ item['exp_amt'] | number:'1.2-2' }}
                        </span>
                    </div>
                    <div class="col-2">
                        {{ item['total'] | number:'1.2-2' }}
                    </div>
                </ng-container>
            </div>
            <div class="row rowborder rowbordertop" style="gap: 2;">
                <div class="col-3"></div>
                <div class="col-3 common">
                    <span style="margin-bottom: 5px;">एकूण :-</span>
                </div>

                <!-- <div class="col-3"></div> -->

                <!-- Debit Column -->
                <div class="col-2 common">

                    <span>
                        {{ (dr_opening_bal - debittotal) | number:'1.2-2' }}
                    </span>

                </div>

                <div class="col-2 common">
                    <span>
                        {{ cr_opening_bal - credittotal | number:'1.2-2' }}
                    </span>
                </div>
                <div class="col-2"></div>
            </div>
            <div class="row">
                <div class="col-3"></div>
                <div class="col-3 common">
                    <span>बाकी पुढे :-</span>
                </div>

                <!-- Debit Column -->
                <div class="col-2 common">
                    <span *ngIf="(cr_opening_bal - credittotal) + (dr_opening_bal - debittotal) < 0">
                        {{ (cr_opening_bal - credittotal) + (dr_opening_bal - debittotal) | number:'1.2-2' }}
                    </span>
                </div>

                <!-- Credit Column -->
                <div class="col-2 common">
                    <span *ngIf="(cr_opening_bal - credittotal) + (dr_opening_bal - debittotal) >= 0">
                        {{ (cr_opening_bal - credittotal) + (dr_opening_bal - debittotal) | number:'1.2-2' }}
                    </span>
                </div>
                <div class="col-2"></div>
            </div>
            <div class="row rowborder"></div>

        </div>
        <print-preview-layout-settings class="settings-section"></print-preview-layout-settings>

    </div>
</div>